import { CDN_URL } from '../../constants'

const contentfulCDNUrlRegex = new RegExp('//(images|videos).ctfassets.net', 'giu')

export const updateAssetCDNUrl = (url?: string) => url?.replace(contentfulCDNUrlRegex, CDN_URL) ?? ''
